import { render, staticRenderFns } from "./ProjectSkeleton.vue?vue&type=template&id=7328459a"
import script from "./ProjectSkeleton.vue?vue&type=script&lang=js"
export * from "./ProjectSkeleton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports